module.exports = __webpack_public_path__ + "img/card3.939e6367.png";